import { render, staticRenderFns } from "./kawedanan.vue?vue&type=template&id=fc3ddc1a&"
import script from "./kawedanan.vue?vue&type=script&lang=js&"
export * from "./kawedanan.vue?vue&type=script&lang=js&"
import style0 from "./kawedanan.vue?vue&type=style&index=0&id=fc3ddc1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports